import { useContext } from 'react'

import SupplierJourneyContext from 'contexts/SupplierJourneyContext'

const useSupplierJourney = () => {
  const context = useContext(SupplierJourneyContext)

  if (context === undefined) {
    throw new Error(
      'useSupplierJourney must be used within a SupplierJourneyContext.Provider',
    )
  }

  return {
    accessToken: context.accessToken,
    activeStep: context.activeStep,
    company: context.company,
    companySupplierToken: context.companySupplierToken,
    disableRecaptcha: context.disableRecaptcha,
    handleAcceptedRecaptcha: context.handleAcceptedRecaptcha,
    handleNext: context.handleNext,
    international: context.international,
    isLoading: context.isLoading,
    linkInvalid: context.linkInvalid,
    loadDataWithAnimation: context.loadDataWithAnimation,
    loaded: context.loaded,
    nextDisabled: context.nextDisabled,
    portalToken: context.portalToken,
    recaptcha: context.recaptcha,
    recaptchaRef: context.recaptchaRef,
    refresh: context.refresh,
    resetRecaptcha: context.resetRecaptcha,
    setAccessToken: context.setAccessToken,
    setActiveStep: context.setActiveStep,
    setCompanySupplierId: context.setCompanySupplierId,
    setCompanySupplierToken: context.setCompanySupplierToken,
    setInternational: context.setInternational,
    setNextDisabled: context.setNextDisabled,
    setRecaptcha: context.setRecaptcha,
    setStepInfo: context.setStepInfo,
    setSteps: context.setSteps,
    setSupplier: context.setSupplier,
    setUser: context.setUser,
    stepInfo: context.stepInfo,
    steps: context.steps,
    supplier: context.supplier,
    user: context.user,
  }
}

export default useSupplierJourney
